import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  Fade,
  FormControlLabel,
  Grid,
  Grid2,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../theme";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";

import { setReduxSearchQuery } from "../redux/searchQuery";
import { dealTypes, roomsType, coinsType, propertyTypes } from "../reTypes";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", md: "30%" },
  height: "90%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  direction: "rtl",
};

const SearchButton = () => {
  const [open, setOpen] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const dispatch = useDispatch();

  const handleCheckboxChange = (index) => {
    const id = formCheckBoxes[index].id;

    setCheckedItems((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );

    setSearchQuery((prev) => {
      const next = { ...prev };
      if (next[id] === 1) delete next[id];
      else next[id] = 1;
      return next;
    });
  };

  const handleFieldChange = (id, val) => {
    const isText =
      id === "state" || id === "city" || id === "address" || id === "area";

    if (val === "") {
      setSearchQuery((prev) => {
        const next = { ...prev };
        delete next[id];
        return next;
      });
      return;
    }

    const nextVal = isText ? val : Number(val);

    setSearchQuery((prev) => ({
      ...prev,
      [id]: Number.isNaN(nextVal) ? undefined : nextVal,
    }));
  };

  const handleSubmit = () => {
    // console.log("searchQuery submit:", searchQuery);
    dispatch(setReduxSearchQuery(searchQuery));
    setOpen(false);
  };

  const formCheckBoxes = [
    { label: "מרוהט", id: "furnished" },
    { label: "בריכה", id: "pool" },
    { label: "מיזוג אוויר", id: "air_con" },
    { label: "חניה", id: "parking" },
    { label: "מחסן", id: "storage" },
    { label: "משופץ", id: "reconditioned" },
    { label: "מעליות", id: "elevator" },
    { label: "שומר בכניסה", id: "door_keeper" },
    { label: "גישה לנכים", id: "disabled" },
  ];

  const formFields = [
    { label: "סוג עסקה:", items: dealTypes, rowGroup: 1, id: "deal_type" },
    {
      label: "סוג נכס:",
      items: propertyTypes,
      rowGroup: 1,
      id: "re_type",
    },

    { label: "מ'ר מ:", items: [], rowGroup: 2, id: "square_from" },
    { label: "מ'ר עד:", items: [], rowGroup: 2, id: "square_to" },

    { label: "מדינה:", items: [], rowGroup: 2, id: "state" },
    { label: "עיר:", items: [], rowGroup: 2, id: "city" },

    { label: "כתובת:", items: [], rowGroup: 2, id: "address" },
    { label: "אזור:", items: [], rowGroup: 2, id: "area" },

    { label: "מחיר - מ:", items: [], rowGroup: 3, id: "price_from" },
    { label: "מחיר - עד:", items: [], rowGroup: 3, id: "price_to" },
    { label: "מטבע:", items: coinsType, rowGroup: 3, id: "coin" },

    {
      label: "סטטוס בניין:",
      items: [],
      rowGroup: 2,
      id: "building_status",
    },
    { label: "גיל בניין:", items: [], rowGroup: 2, id: "building_age" },

    { label: "חדרים - מ:", items: roomsType, rowGroup: 2, id: "rooms_from" },
    { label: "חדרים - עד:", items: roomsType, rowGroup: 2, id: "rooms_to" },

    { label: "קומות - מ:", items: [], rowGroup: 2, id: "floor_from" },
    { label: "קומות - עד:", items: [], rowGroup: 2, id: "floor_to" },

    {
      label: "מספר קומות:",
      items: [],
      rowGroup: 1,
      id: "number_of_stories",
    },
  ];

  return (
    <Grid container dir="rtl" sx={{ p: "10px" }} alignItems="center">
      <Grid item xs={12}>
        <Grid
          container
          dir="rtl"
          alignItems="center"
          sx={{ cursor: "pointer" }}
          onClick={() => setOpen(true)}
        >
          <SearchIcon
            fontSize="large"
            sx={{ color: theme.palette.primary.main }}
          />
          <Typography fontWeight="bold" sx={{ pl: 1 }}>
            חיפוש נכס
          </Typography>
        </Grid>
      </Grid>

      <Modal
        dir="rtl"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight="bold">
                פרטי נכס
              </Typography>
              <CloseIcon
                onClick={() => setOpen(false)}
                sx={{ cursor: "pointer" }}
              />
            </Grid>

            <Grid container spacing={1} sx={{ pt: "20px" }}>
              {formFields.map((field, index) => (
                <Grid item xs={12 / field.rowGroup} key={index}>
                  <Typography>{field.label}</Typography>

                  {field.items.length > 0 ? (
                    <TextField
                      select
                      size="small"
                      fullWidth
                      value={searchQuery[field.id] || ""}
                      onChange={(e) =>
                        handleFieldChange(field.id, e.target.value)
                      }
                      // slotProps={{
                      //   htmlInput: {
                      //     dir: "rtl",
                      //     style: { textAlign: "right" },
                      //   },
                      // }}
                    >
                      {field.items.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          dir="rtl"
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    <TextField
                      size="small"
                      fullWidth
                      // slotProps={{
                      //   htmlInput: {
                      //     dir: "rtl",
                      //     style: { textAlign: "right" },
                      //   },
                      // }}
                      value={searchQuery[field.id] || ""}
                      onChange={(e) =>
                        handleFieldChange(field.id, e.target.value)
                      }
                    />
                  )}
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2 container justifyContent="center" sx={{ pt: "20px" }}>
                {formCheckBoxes.map((item, index) => (
                  <Grid item xs={4} key={index}>
                    <FormControlLabel
                      // slotProps={{ typography: { textAlign: "right" } }}
                      dir="rtl"
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                      control={
                        <Checkbox
                          disableRipple
                          checked={checkedItems.includes(index)}
                          onChange={() => handleCheckboxChange(index)}
                        />
                      }
                      label={<span>{item.label}</span>}
                    />
                  </Grid>
                ))}
              </Grid2>
            </Box>

            <Grid container justifyContent="center" sx={{ pt: "20px" }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  width: "100px",
                  borderRadius: "10px",
                }}
              >
                חפש
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </Grid>
  );
};

export default SearchButton;
